import { SendMessage } from './socket';

export function TrackPageView(path:string) {
    SendMessage({
        subject: "tracking/pages/views",
        payload: {
            path,
        }
    })
}